import type { RouteObject } from "react-router-dom";
import { withCompanyPrefix } from "../route.utils";
import { Spinner } from "@/components/ui/v2/spinner";
import { CompanyAIAssistant } from "@/pages/(home)/(company)/ai-assistant";

export const COMPANY_AI_ASSISTANT_SESSION_ID_KEY = "sessionId";

export enum COMPANY_AI_ASSISTANT_PATH_SEGMENTS {
  ROOT = "ai-assistant",
  CHAT_SESSION = `:${COMPANY_AI_ASSISTANT_SESSION_ID_KEY}`,
}

export const companyAIAssistantRoutes: RouteObject = {
  path: COMPANY_AI_ASSISTANT_PATH_SEGMENTS.ROOT,
  HydrateFallback: Spinner,
  handle: { breadcrumb: "AI Assistant" },
  children: [
    {
      index: true,
      Component: CompanyAIAssistant,
    },
    {
      path: `:${COMPANY_AI_ASSISTANT_SESSION_ID_KEY}`,
      handle: { breadcrumb: "Chat Session" },
      Component: CompanyAIAssistant,
    },
  ],
};

export const COMPANY_AI_ASSISTANT_PATHS = Object.freeze({
  ROOT: withCompanyPrefix(COMPANY_AI_ASSISTANT_PATH_SEGMENTS.ROOT),
  CHAT_SESSION: (sessionId: string) =>
    withCompanyPrefix(`${COMPANY_AI_ASSISTANT_PATH_SEGMENTS.ROOT}/${sessionId}`),
});
